(function () {
  // ============================================================
  // Carrot – Cherry Bag Charm guard
  // 1. Piggybacks the charm onto bag add-to-cart (single request)
  // 2. Blocks adding the charm when no bag is in the cart
  // 3. Removes bag + charm in ONE atomic request (no timing gap)
  // 4. Sweeps orphaned charms on page load and before checkout
  // ============================================================

  var CHARM_HANDLE = 'cherry-bag-charm';
  var CHARM_VARIANT_IDS = [52297188737326]; // keep in sync if charm variants change

  var origFetch = window.fetch;

  function isCharmVariantId(id) {
    return CHARM_VARIANT_IDS.indexOf(parseInt(id, 10)) !== -1;
  }

  function isCharmItem(item) {
    return item.handle === CHARM_HANDLE || isCharmVariantId(item.variant_id);
  }

  function getCart() {
    return origFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function charmEl() {
    return document.querySelector('.charm-addon');
  }

  function pageCharmVariantId() {
    var el = charmEl();
    if (!el) return null;
    var id = parseInt(el.dataset.charmVariantId, 10);
    return isNaN(id) ? null : id;
  }

  function charmChecked() {
    var el = charmEl();
    var cb = el && el.querySelector('.charm-addon__checkbox');
    return !!(cb && cb.checked);
  }

  function parseBody(body) {
    try {
      if (!body) return null;
      if (body instanceof FormData || body instanceof URLSearchParams) {
        var o = {};
        body.forEach(function (v, k) { o[k] = v; });
        return o;
      }
      if (typeof body === 'string') return JSON.parse(body);
    } catch (e) { /* noop */ }
    return null;
  }

  function jsonResponse(obj, status) {
    return new Response(JSON.stringify(obj), {
      status: status || 200,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  // ---------- /cart/add ----------
  async function handleAdd(url, input, init) {
    try {
      var body = init && init.body;
      var charmId = pageCharmVariantId();

      // (A) Piggyback: bag PDP add with charm checkbox ticked
      if (charmId && charmChecked() && body instanceof FormData) {
        var fd = body;
        var mainId = parseInt(fd.get('id'), 10);
        var qty = parseInt(fd.get('quantity') || '1', 10) || 1;

        if (mainId && !isCharmVariantId(mainId)) {
          var payload = {
            items: [
              { id: mainId, quantity: qty },
              { id: charmId, quantity: 1 }
            ]
          };
          if (fd.get('sections')) payload.sections = fd.get('sections');
          if (fd.get('sections_url')) payload.sections_url = fd.get('sections_url');

          var headers = new Headers((init && init.headers) || {});
          headers.set('Content-Type', 'application/json');
          headers.set('Accept', 'application/javascript');

          var opts = Object.assign({}, init, { body: JSON.stringify(payload), headers: headers });
          var res = await origFetch.call(window, url, opts);

          try {
            var data = await res.clone().json();
            if (res.ok && data && data.items && data.items.length) {
              var reshaped = Object.assign({}, data, data.items[0]);
              reshaped.items = data.items;
              return jsonResponse(reshaped, res.status);
            }
          } catch (e) { /* return original response */ }
          return res;
        }
      }

      // (B) Block: adding only charm(s) when no bag is in the cart
      var parsed = parseBody(body);
      var addedIds = [];
      if (parsed) {
        if (parsed.items && parsed.items.length) {
          parsed.items.forEach(function (it) { addedIds.push(parseInt(it.id, 10)); });
        } else if (parsed.id) {
          addedIds.push(parseInt(parsed.id, 10));
        }
      }
      var addsOnlyCharm = addedIds.length > 0 && addedIds.every(isCharmVariantId);
      if (addsOnlyCharm) {
        var cart = await getCart();
        var hasBag = cart.items.some(function (i) { return !isCharmItem(i); });
        if (!hasBag) {
          return jsonResponse({
            status: 422,
            message: 'Cart Error',
            description: 'The bag charm can only be purchased together with a bag.'
          }, 422);
        }
      }
    } catch (e) { /* fall through to untouched request */ }
    return origFetch.call(window, input, init);
  }

  // ---------- /cart/change ----------
  async function handleChange(url, input, init) {
    try {
      var parsed = parseBody(init && init.body);
      if (!parsed) return origFetch.call(window, input, init);

      var newQty = parseInt(parsed.quantity, 10);
      if (isNaN(newQty) || newQty > 0) {
        var passRes = await origFetch.call(window, input, init);
        scheduleSweep();
        return passRes;
      }

      // A line is being removed — find out which
      var cart = await getCart();
      var target = null;
      if (parsed.line) {
        target = cart.items[parseInt(parsed.line, 10) - 1] || null;
      } else if (parsed.id) {
        target = cart.items.filter(function (i) {
          return i.key === parsed.id || String(i.variant_id) === String(parsed.id);
        })[0] || null;
      }

      // Removing the charm itself, or unknown target → pass through
      if (!target || isCharmItem(target)) {
        return origFetch.call(window, input, init);
      }

      var bagsLeft = cart.items.some(function (i) {
        return !isCharmItem(i) && i.key !== target.key;
      });
      var charmKeys = cart.items.filter(isCharmItem).map(function (i) { return i.key; });

      if (bagsLeft || charmKeys.length === 0) {
        return origFetch.call(window, input, init);
      }

      // Last bag being removed while charm is in cart:
      // remove BOTH in one atomic request — zero gap.
      var updates = {};
      updates[target.key] = 0;
      charmKeys.forEach(function (k) { updates[k] = 0; });

      var payload2 = { updates: updates };
      if (parsed.sections) payload2.sections = parsed.sections;
      if (parsed.sections_url) payload2.sections_url = parsed.sections_url;

      return origFetch.call(window, '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload2)
      });
    } catch (e) { /* fall through */ }
    return origFetch.call(window, input, init);
  }

  // ---------- orphan sweep ----------
  var sweeping = false;
  function sweep() {
    if (sweeping) return Promise.resolve(false);
    sweeping = true;
    return getCart()
      .then(function (cart) {
        var charmKeys = cart.items.filter(isCharmItem).map(function (i) { return i.key; });
        var hasBag = cart.items.some(function (i) { return !isCharmItem(i); });
        if (charmKeys.length === 0 || hasBag) {
          sweeping = false;
          return false;
        }
        var updates = {};
        charmKeys.forEach(function (k) { updates[k] = 0; });
        return origFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          sweeping = false;
          return true;
        });
      })
      .catch(function () {
        sweeping = false;
        return false;
      });
  }

  function scheduleSweep() {
    setTimeout(function () {
      sweep().then(function (removed) {
        if (removed && location.pathname.indexOf('/cart') === 0) location.reload();
      });
    }, 50);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleSweep();
  });

  // ---------- checkout guard ----------
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var isCheckout =
      (e.submitter && e.submitter.name === 'checkout') ||
      (form.getAttribute('action') || '').indexOf('/checkout') !== -1;
    if (!isCheckout) return;
    e.preventDefault();
    sweep()
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () { window.location.href = '/checkout'; });
  }, true);

  // ---------- fetch interceptor ----------
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/cart/add') !== -1) return handleAdd(url, input, init);
      if (url.indexOf('/cart/change') !== -1) return handleChange(url, input, init);
      if (url.indexOf('/cart/update') !== -1) {
        return origFetch.call(window, input, init).then(function (res) {
          scheduleSweep();
          return res;
        });
      }
    } catch (e) { /* noop */ }
    return origFetch.call(window, input, init);
  };

  // ---------- lightbox ----------
  document.addEventListener('click', function (e) {
    var lightbox = document.getElementById('charmLightbox');
    if (!lightbox) return;
    if (e.target.closest('.charm-addon__thumb')) {
      lightbox.classList.add('is-open');
    } else if (e.target.closest('#charmLightboxClose') || e.target === lightbox) {
      lightbox.classList.remove('is-open');
    }
  });
})();